import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import JsonLd from '@/components/feature/JsonLd';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/gossip';

export default function FaqPage() {
  return (
    <div className="page-enter min-h-screen bg-background-50">
      <title>常见问题 - 内容、分享群与分享码说明 | 爆瓜福利</title>
      <meta
        name="description"
        content="爆瓜福利常见问题解答，涵盖内容方向、如何加入分享群、分享链接与分享码区别、内容更新频率与投稿反馈方式，帮助你快速上手。"
      />
      <meta name="keywords" content="爆瓜福利常见问题,爆瓜福利分享群怎么加入,分享码是什么,内容更新频率" />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: { '@type': 'Answer', text: item.a },
          })),
        }}
      />

      <SiteHeader />
      <main className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />

        <header className="mt-6 text-center">
          <span className="text-xs font-medium tracking-[0.25em] text-primary-600">FAQ</span>
          <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
            我们把用户问得最多的几个问题整理在一起，如果这里没有你想要的答案，欢迎随时联系我们。
          </p>
        </header>

        <div className="mt-10">
          <FaqAccordion items={faqs} />
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2">
          <Link
            to="/community"
            className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-group-line text-xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-base font-bold text-foreground-950">前往分享社区</h2>
            <p className="mt-2 text-xs leading-6 text-foreground-600">
              查看当前开放的分享群、分享链接与分享码，按步骤加入一起讨论。
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-700">
              立即查看
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>

          <Link
            to="/about"
            className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-mail-send-line text-xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-base font-bold text-foreground-950">联系与投稿</h2>
            <p className="mt-2 text-xs leading-6 text-foreground-600">
              想提供线索或反馈内容问题？在关于我们页面可以找到联系方式。
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-700">
              去关于我们
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        </div>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}